<template>
 <div class="loading_box">
     <van-loading size="24px" color="#fff" type="spinner" vertical>加载中...</van-loading>
 </div>
</template>

<script>
 export default {
     
 }
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";
  .loading_box{
      @include center();
      @include wh(2rem,1.5rem);
      background: rgba(0,0,0,.2);
      border-radius: .1rem;
      position: fixed;
  }
  .van-loading{
    margin: .25rem;
  }
 
</style>
